import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { ReactComponent as DialogCheck } from "../assets/images/dialog-check.svg";
import CloseIcon from "../assets/images/plus-circle-fill.svg";

const SimpleDialog = (props) => {
  const { t } = useTranslation()
  const handleClose = () => {
    props.setValue(false)
  };
  return (
    <React.Fragment>
      <Dialog
        onBackdropClick={() => {return false}}
        open={props.open}
        onClose={() => props.page === true ? props.doDirect() : handleClose()}
        maxWidth="xs"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {/* {props.noClose === true ?
            null
            :
            <Box sx={{ position: "absolute", right: 0, margin: "20px 20px 0  0", top: 0 }} className="clickable" onClick={() => props.page === true ? props.doDirect() : handleClose()}><img src={CloseIcon} alt="browser" /></Box>
          } */}
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }} pt={4} component="div">
            <DialogCheck></DialogCheck>
            <Typography color="primary" variant="h3" mt={3}>{props.save === true ? t("label.saved") : t("label.done")}</Typography>
            <Typography textAlign="center" mt={2} sx={{whiteSpace: "pre-line", color: "#404349"}}>{props.text}
              {props.subTitle === undefined ?
                <br />
                :
                null}
              {props.subTitle === undefined ?
                t(`label.success`)
                :
                null}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <Button onClick={() => props.page === true ? props.doDirect() : handleClose()} size="large" variant="contained" sx={{ width: '300px' }} style={{textTransform: 'none'}}>{t(`label.close`)}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default SimpleDialog;
